import { Component, effect, ElementRef, input, ViewChild } from '@angular/core';
import { marked } from 'marked';

@Component({
  selector: 'gea-shop-markdown',
  template: `<div #mdEl></div>`,
  standalone: false
})
export class MarkdownComponent {

  @ViewChild('mdEl', { read: ElementRef, static: true }) public mdEl!: ElementRef

  public markdown = input<string | undefined>(undefined)

  constructor(
  ) {
    effect(() => {
      const md = this.markdown()
      if (md) {
        const r = marked(md, {async: false})
        this.mdEl.nativeElement.innerHTML = r
      } else {
        this.mdEl.nativeElement.innerHTML = ""
      }
    })
  }
}
